










import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import BaseModal from '@/components/modals/BaseModal.vue';
import { ModalHelper } from '@/helpers/modal-helper';

@Component({
	name: 'OfferReporterSuccessModal',
	components: { BaseModal },
})
export default class OfferReporterSuccessModal extends Vue {
	@Prop({ default: null }) email: string;
	@Prop({ default: 3000 }) closeDelay: number;

	mounted() {
		setTimeout(() => {
			ModalHelper.close();
		}, this.closeDelay);
	}
}
